export default __webpack_public_path__ + "static/media/wellness-test.e4329754.svg";